export default __webpack_public_path__ + "static/media/plp-shape-right.9a283020.svg";